<template>
  <div style="background: #eee">
    <van-sticky>
      <van-nav-bar
        title="合并支付记录"
        left-text="返回"
        left-arrow
        @click-left="goback"
      />
    </van-sticky>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell-group
        v-for="(item, index) in payList"
        :key="index"
        style="margin: 1.2rem; text-align: left"
        inset
      >
        <div style="font-size: 1.6rem; padding-top: 2rem; text-align: center">
         {{ item.settlementBatchName }}
        </div>
        <div
          style="
            width: 0;
            height: 0;
            border: 4rem solid transparent;
            border-top: none;
            float: right;
            margin-top: -3rem;
            margin-right: 0.8rem;
            position: relative;
            border-right-color:green;
            margin-bottom: 0.4rem;
          "
        >
          <span
            style="
              position: absolute;
              width: 3rem;
              height: 4rem;
              line-height: 2rem;
              margin-left: 1.4rem;
              color: #fff;
              font-size: 0.8rem;
            "
           
            >已支付</span
          >
        </div>
        <van-field
          label="收到金额"
          :value="item.allocatedAmount"
          input-align="right"
          readonly
          label-width="5rem"
        />
        <van-field
          label="公司"
          :value="item.companyIdStr"
          input-align="right"
          readonly
          label-width="5rem"
        />
        <van-field
          label="操作人"
          :value="item.createdByStr"
          input-align="right"
          readonly
          label-width="5rem"
        />
        <van-field
          label="操作时间"
          :value="item.createTime"
          input-align="right"
          readonly
          label-width="5rem"
        />
      </van-cell-group>
    </van-list>
  </div>
</template>
<script>
export default {
  name: "DeductionRecords",
  data() {
    return {
      loading: false,
      finished: false,
      payList: [],
      total: 0,
      page: 1,
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    onLoad() {
      this.finished = true;
      this.getPayData();
    },
    getPayData(){
      this.axios({
        url:'v1/web/payment-record-order-relation/list?paymentId=' + this.$route.query.id,
        method:'get',
      }).then(res=>{
        if(res.data.code == 200){
          this.payList = res.data.data
          this.loading = false
        }
      })
    },
  },
};
</script>
